export default __webpack_public_path__ + "static/media/eventicon.0e9a2b62.svg";